import { renderCardMCQ } from "../MCQ";

const renderCardReOrder = (block: any) => renderCardMCQ(block, false);
export default renderCardReOrder;
